import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Login from 'components/Login/Login';
import LoginCallback from 'components/Login/LoginCallback';
import SilentRenew from 'components/Login/SilentRenew';
import Logout from 'components/Logout/Logout';
import PrivateRoute from 'components/PrivateRoute/PrivateRoute';

export interface BaseAppProps {
	basename: string;
}

class BaseApp extends Component<BaseAppProps> {
	render() {
		return (
			<Router basename={this.props.basename}>
				<Switch>
					<Route exact path="/login" component={Login} />
					<Route exact path="/login-callback" component={LoginCallback} />
					<Route exact path="/login-silent-renew" component={SilentRenew} />
					<Route exact path="/logout" component={Logout} />
					<PrivateRoute redirect="/login">{this.props.children}</PrivateRoute>
				</Switch>
			</Router>
		);
	}
}

export default BaseApp;
